import { ChainId } from '@pancakeswap/sdk'
import {
  BIT_QUERY,
  INFO_CLIENT,
  STABLESWAP_SUBGRAPH_CLIENT,
  INFO_CLIENT_ETH,
  V3_SUBGRAPH_URLS, V2_SUBGRAPH_URLS,
} from 'config/constants/endpoints'
import { GraphQLClient } from 'graphql-request'
import { SApiProvider } from 'utils/SApiProvider'
import { INFO_CLIENT_WITH_CHAIN } from '../config/constants/endpoints'

// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
export const getGQLHeaders = (endpoint: string) => {
  if (endpoint === INFO_CLIENT && process.env.NEXT_PUBLIC_NODE_REAL_HEADER) {
    return {
      origin: process.env.NEXT_PUBLIC_NODE_REAL_HEADER,
    }
  }
  return undefined
}

export const infoClient = new GraphQLClient(INFO_CLIENT)

export const infoClientWithChain = (chainId: number) => {
  if (INFO_CLIENT_WITH_CHAIN[chainId]) {
    return new GraphQLClient(INFO_CLIENT_WITH_CHAIN[chainId], {
      headers: getGQLHeaders(INFO_CLIENT_WITH_CHAIN[chainId]),
    })
  }
  return undefined
}

export const v3Clients = {
  // [ChainId.ETHEREUM]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.ETHEREUM]),
  // [ChainId.GOERLI]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.GOERLI]),
  // [ChainId.MANTLE]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE]),
  // [ChainId.MANTLE_TESTNET]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE_TESTNET]),

  [ChainId.MANTLE]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE]),
  [ChainId.MANTLE_TESTNET]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.MANTLE_TESTNET]),
}

export const v2Clients = {
  [ChainId.MANTLE]: new GraphQLClient(V2_SUBGRAPH_URLS[ChainId.MANTLE]),
  [ChainId.MANTLE_TESTNET]: new GraphQLClient(V2_SUBGRAPH_URLS[ChainId.MANTLE_TESTNET]),
}

export const v3SApiProvider = {
  [ChainId.MANTLE]: new SApiProvider('https://www.perpstreet.xyz/s_api'),
  [ChainId.MANTLE_TESTNET]: new SApiProvider('https://testnet.perpstreet.xyz/s_api'),
}

export const v3InfoClients = {
  ...v3Clients,
  // [ChainId.MANTLE]: new GraphQLClient(INFO_CLIENT_WITH_CHAIN[ChainId.MANTLE]),
}

export const infoClientETH = new GraphQLClient(INFO_CLIENT_ETH)

export const infoStableSwapClient = new GraphQLClient(STABLESWAP_SUBGRAPH_CLIENT)

export const infoServerClient = new GraphQLClient(INFO_CLIENT, {
  timeout: 5000,
  headers: {
    origin: 'https://pancakeswap.finance',
  },
})

export const stableSwapClient = new GraphQLClient(STABLESWAP_SUBGRAPH_CLIENT)

export const bitQueryServerClient = new GraphQLClient(BIT_QUERY, {
  headers: {
    // only server, no `NEXT_PUBLIC` not going to expose in client
    'X-API-KEY': process.env.BIT_QUERY_HEADER,
  },
  timeout: 5000,
})
